import React from "react"
import Image from "next/image"
import { ImageItem } from "./types"
import Link from "next/link"
type Props = {
  topCategoryItems: ImageItem[]
}

const TopCategoryBar = ({ topCategoryItems }: Props) => {
  const S3_IMAGE_BASE_URL = process.env.NEXT_PUBLIC_S3_IMAGE_BASE_URL
  const topCategoryItemsMaps = Array.isArray(topCategoryItems)
    ? topCategoryItems
    : JSON.parse(topCategoryItems || "[]")


  return (
    <>
      <div className="w-full flex items-center gap-4 overflow-x-auto py-3">
        {topCategoryItemsMaps.map((item: ImageItem, index: number) => (
          <div key={index} className="flex flex-col items-center gap-2 cursor-pointer">
            <Link href={`/categories/${item.product_category_handle}`}>
              <div className="relative w-16 h-16 sm:w-20 sm:h-20 rounded-full border-[3px] border-muted-accent hover:border-button-primary transition-all ease-in-out duration-150 shadow-md hover:shadow-xl hover:scale-105 overflow-hidden bg-bg-component">
                <Image
                  src={`${S3_IMAGE_BASE_URL}${item.image}`}
                  fill
                  alt={item.name}
                  style={{ objectFit: "cover" }}
                />
              </div>
            </Link>
            <span className="text-xs sm:text-sm text-foreground text-center line-clamp-2 max-w-[80px]">
              {item.name}
            </span>
          </div>
        ))}
      </div>
    </>
  )
}

export default TopCategoryBar
